import React from 'react';
import LocalSeoPage from './LocalSeoPage';

const DepannageGenevois: React.FC = () => (
  <LocalSeoPage
    city="Genève"
    cityShort="Genève"
    slug="depannage-informatique-region-geneve"
    metaTitle="Dépannage Informatique Genève | SOS IT Services"
    metaDescription="Dépannage informatique dans la région de Genève. Intervention rapide à domicile ou à distance. Diagnostic gratuit. Appelez maintenant !"
    intro="Vous habitez dans la région de Genève et votre ordinateur vous pose des problèmes ? Nous intervenons rapidement à domicile ou à distance dans toute la région, de Saint-Julien-en-Genevois à Annemasse en passant par Viry et Valleiry. Un diagnostic gratuit, une solution claire et un tarif honnête."
    nearbyTowns={[
      { name: 'Saint-Julien-en-Genevois', link: '/depannage-informatique-saint-julien-en-genevois' },
      { name: 'Annemasse', link: '/depannage-informatique-annemasse' },
      { name: 'Annecy', link: '/depannage-informatique-annecy' },
      { name: 'Gex', link: '/depannage-informatique-gex' },
      { name: 'Viry', link: '/depannage-informatique-viry' },
      { name: 'Valleiry', link: '/depannage-informatique-valleiry' },
      { name: 'Ferney-Voltaire', link: '/depannage-informatique-ferney-voltaire' },
      { name: 'Saint-Genis-Pouilly', link: '/depannage-informatique-saint-genis-pouilly' },
      { name: 'Divonne-les-Bains', link: '/depannage-informatique-divonne-les-bains' },
      { name: 'Prévessin-Moëns', link: '/depannage-informatique-prevessin-moens' },
    ]}
    internalLinks={[
      { label: 'Dépannage informatique à Saint-Julien-en-Genevois', href: '/depannage-informatique-saint-julien-en-genevois' },
      { label: 'Dépannage informatique à Annemasse', href: '/depannage-informatique-annemasse' },
      { label: 'Dépannage informatique à Annecy', href: '/depannage-informatique-annecy' },
      { label: 'Dépannage informatique à Gex', href: '/depannage-informatique-gex' },
      { label: 'Dépannage informatique à Viry', href: '/depannage-informatique-viry' },
      { label: 'Dépannage informatique à Valleiry', href: '/depannage-informatique-valleiry' },
      { label: 'Dépannage informatique à Ferney-Voltaire', href: '/depannage-informatique-ferney-voltaire' },
      { label: 'Dépannage informatique à Saint-Genis-Pouilly', href: '/depannage-informatique-saint-genis-pouilly' },
      { label: 'Dépannage informatique à Divonne-les-Bains', href: '/depannage-informatique-divonne-les-bains' },
      { label: 'Dépannage informatique à Prévessin-Moëns', href: '/depannage-informatique-prevessin-moens' },
    ]}
  />
);

export default DepannageGenevois;
